<form (ngSubmit)="save()" [formGroup]="form">
	<div [alarisLoading]="service.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ rule.ID ? ('translation_rules.edit' | translate) : ('translation_rules.add' | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
            <alaris-input formControlName="Name" [errors]="errors">
                {{ 'translation_rules.name' | translate }}
            </alaris-input>
            <alaris-checkbox formControlName="Status" [indeterminate]="false">
                {{ 'translation_rules.active' | translate }}
            </alaris-checkbox>
            <alaris-select2
                    formControlName="SourceType"
                    [alarisLoading]="service.loading$"
                    [label]="'translation_rules.source_type' | translate"
                    [errors]="errors">
                <alaris-select-filter2 [formControl]="ProvidersFilter"></alaris-select-filter2>
                @for (provider of providers; track provider) {
                    <alaris-options2 [value]="provider.Name">
                        {{ provider.Name }}
                    </alaris-options2>
                }
            </alaris-select2>
            <alaris-text-area formControlName="ResponseCodes" [errors]="errors" mode="tag"
                              [alarisTooltip]="'translation_rules.response_code_null' | translate">
                {{ 'translation_rules.response_code' | translate }}
            </alaris-text-area>
            <alaris-select2
                    formControlName="SystemCode"
                    [alarisLoading]="service.loading$"
                    [label]="'translation_rules.system_code' | translate"
                    [errors]="errors">
                <alaris-select-filter2 [formControl]="SystemCodeFilter"></alaris-select-filter2>
                @for (code of codes; track code.ID) {
                    <alaris-options2 [value]="code.Value">
                        {{ code.Value + '\n' + code.Description }}
                    </alaris-options2>
                }
            </alaris-select2>
			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'gl.reset' | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button [disabled]="form.invalid || !form.dirty" alaris-button bType="primary" size="lg"
				type="submit">
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ 'gl.submit' | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ 'actions.close' | translate }}
			</button>
		</div>
	</div>
</form>